import React, { useEffect } from "react";
import { Location, navigate } from "@reach/router";
import { AuthConsumer } from "../helpers/AuthContext";

// Routes a logged-in user with an UNFINISHED profile is allowed to be on.
// Everything else bounces them to the profile form, making completion
// compulsory (Google signups land here with an empty profile).
const ALLOWED_WHEN_INCOMPLETE = ["/complete-profile", "/logout"];

function normalize(pathname) {
  const p = (pathname || "/").replace(/\/+$/, "");
  return p === "" ? "/" : p;
}

// Renders nothing — it's a side-effect-only guard. Runs on every route
// change (and on each full-page load, since the app re-mounts) and, when a
// signed-in account hasn't completed its profile, redirects to the form.
function Gate({ pathname, isLoggedIn, profileComplete }) {
  useEffect(() => {
    if (!isLoggedIn || profileComplete) return;
    const p = normalize(pathname);
    if (!ALLOWED_WHEN_INCOMPLETE.includes(p)) {
      navigate("/complete-profile");
    }
  }, [pathname, isLoggedIn, profileComplete]);
  return null;
}

const RouteGuard = () => (
  <AuthConsumer>
    {({ Auth, ProfileComplete }) => {
      const isLoggedIn = Auth === "Admin" || Auth === "User";
      return (
        <Location>
          {({ location }) => (
            <Gate
              pathname={location.pathname}
              isLoggedIn={isLoggedIn}
              // Treat only an explicit false as incomplete.
              profileComplete={ProfileComplete !== false}
            />
          )}
        </Location>
      );
    }}
  </AuthConsumer>
);

export default RouteGuard;
